<div class="bulk-job-dialog">
  <div class="bjs-header">
    <h2 mat-dialog-title>Mark Shipped in Impress — Results</h2>
    <button mat-icon-button (click)="close()">
      <mat-icon style="color: #d9534f;">close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <!-- Recent uploads list -->
    <div *ngIf="showRecent">
      <h4 class="bjs-subtitle">Recent uploads</h4>
      <div *ngIf="!recentJobs.length" class="bjs-empty">No recent uploads.</div>
      <table *ngIf="recentJobs.length" class="table table-sm bjs-recent">
        <thead>
          <tr>
            <th>#</th>
            <th>When</th>
            <th>Status</th>
            <th>Processed</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let j of recentJobs">
            <td>{{ j.BulkJobId }}</td>
            <td>{{ j.CreatedDate | date: "short" }}</td>
            <td>
              <span class="bjs-chip" [ngClass]="'bjs-' + (j.Status || '').toLowerCase()">{{ j.Status }}</span>
            </td>
            <td>{{ j.Processed }}/{{ j.Total }}</td>
            <td>
              <button mat-button color="primary" (click)="openJob(j.BulkJobId)">Open</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Single job status -->
    <div *ngIf="!showRecent">
      <button *ngIf="recentJobs.length" mat-button class="bjs-back" (click)="backToRecent()">
        <mat-icon>arrow_back</mat-icon> Recent uploads
      </button>

      <div *ngIf="loading && !job" class="bjs-empty">Loading…</div>

      <div *ngIf="job">
        <div class="bjs-status-row">
          <span class="bjs-chip" [ngClass]="'bjs-' + (job.Status || '').toLowerCase()">{{ job.Status }}</span>
          <span class="bjs-progress-text">{{ job.Processed }} of {{ job.Total }} processed</span>
        </div>
        <mat-progress-bar
          [mode]="job.Status === 'Queued' ? 'indeterminate' : 'determinate'"
          [value]="progress"
        ></mat-progress-bar>

        <div class="bjs-counts">
          <span class="bjs-count bjs-added">Added: {{ job.AddedCount }}</span>
          <span class="bjs-count bjs-alreadyshipped">Already shipped: {{ job.AlreadyShippedCount }}</span>
          <span class="bjs-count bjs-impresserror">Errors: {{ job.ImpressErrorCount }}</span>
          <span class="bjs-count bjs-notracking">No tracking: {{ job.NoTrackingCount }}</span>
          <span class="bjs-count bjs-noorderdesklink">No OrderDesk link: {{ job.NoOrderDeskLinkCount }}</span>
          <span class="bjs-count bjs-notfound">Not found: {{ job.NotFoundCount }}</span>
        </div>

        <div *ngIf="job.ErrorMessage" class="bjs-joberror">{{ job.ErrorMessage }}</div>

        <div class="bjs-toolbar">
          <mat-form-field appearance="outline" class="bjs-filter">
            <mat-label>Filter outcome</mat-label>
            <mat-select [(value)]="outcomeFilter" (selectionChange)="applyFilter()">
              <mat-option *ngFor="let o of outcomes" [value]="o">{{ o }}</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-raised-button color="primary" [disabled]="downloading" (click)="download()">
            <mat-icon>download</mat-icon> Download results
          </button>
        </div>

        <table class="table table-sm bjs-items">
          <thead>
            <tr>
              <th>Order #</th>
              <th>Outcome</th>
              <th>Next step</th>
              <th>Detail</th>
              <th>Tracking</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let it of filteredItems">
              <td>{{ it.OrderNumber }}</td>
              <td>
                <span class="bjs-chip" [ngClass]="'bjs-' + (it.Outcome || '').toLowerCase()">{{ it.Outcome }}</span>
              </td>
              <td>{{ nextStep(it.Outcome) }}</td>
              <td class="bjs-detail">{{ it.Message }}</td>
              <td>{{ it.TrackingUsed }}</td>
            </tr>
            <tr *ngIf="!filteredItems.length">
              <td colspan="5" class="bjs-empty">No rows.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Close</button>
  </mat-dialog-actions>
</div>
